import { useRouter } from 'next/navigation';
import { FC } from 'react';
import { UseFormReturn, SubmitHandler } from 'react-hook-form';
import { useRecoilValue } from 'recoil';

import { SusnetImage } from '~/components/_wrapper/SusnetImage';
import { CurrentUserState } from '~/state/currentUser';

import { Form } from './form';
import {
  StyledSide,
  StyledSideText,
  StyledSideTitle,
  StyledSideButtons,
  StyledSidePrimaryButton,
  StyledSideSecondaryButton,
  StyledSideConfirmText,
} from './side.styles';

type Props = {
  form: UseFormReturn<any>;
  submitted: boolean;
  onSubmit: SubmitHandler<any>;
};

export const Side: FC<Props> = ({ submitted, onSubmit, form }) => {
  const router = useRouter();
  const currentUser = useRecoilValue(CurrentUserState);
  const { getValues } = form;
  const values = getValues();

  if (submitted) {
    return (
      <StyledSide>
        <StyledSideText>
          <StyledSideTitle>ご入力内容</StyledSideTitle>
        </StyledSideText>
        <StyledSideConfirmText>
          貴社名
          <br />
          <b>{values.company}</b>
          <br />
          <br />
          部署名
          <br />
          <b>{values.department}</b>
          <br />
          <br />
          お役職
          <br />
          <b>{values.post || '回答なし'}</b>
          <br />
          <br />
          ご連絡先メールアドレス
          <br />
          <b>{values.email}</b>
          <br />
          <br />
          本レポートについてどのように知りましたか？
          <br />
          <b>{values.how}</b>
          <br />
          <br />
          本レポートご請求の背景
          <br />
          <b>{values.background || '回答なし'}</b>
        </StyledSideConfirmText>
      </StyledSide>
    );
  } else {
    return (
      <StyledSide>
        <StyledSideText>
          資料ダウンロードご希望の
          <br />
          <StyledSideTitle>NPO/社会的事業者の方</StyledSideTitle>
          <br />
          「サステナNet」にログインまたは団体登録をすると全文を閲覧することができます。
        </StyledSideText>
        {currentUser?.type === 'org' ? (
          <StyledSideButtons
            onClick={() => {
              window.open(
                'https://drive.google.com/uc?export=download&id=1Lknsa59zcpbODiXWrZgBJnC3CMGlvF3C',
              );
            }}
          >
            <StyledSidePrimaryButton>レポートダウンロード</StyledSidePrimaryButton>
          </StyledSideButtons>
        ) : (
          <div>
            <StyledSideButtons>
              <StyledSidePrimaryButton
                onClick={() => {
                  router.push('/login?redirect_to=%252Fsurvey');
                }}
              >
                ログイン
              </StyledSidePrimaryButton>
              <StyledSideSecondaryButton
                onClick={() => {
                  router.push('/org/signup?redirect_to=%252Fsurvey');
                }}
              >
                団体登録
              </StyledSideSecondaryButton>
            </StyledSideButtons>
            <Form form={form} onSubmit={onSubmit} />
          </div>
        )}
      </StyledSide>
    );
  }
};
